<template>
  <div class="jsc-bg">
    <!-- 顶部 -->
    <div class="top">
      <div class="sys-date">{{ today }}</div>
      <div class="sys-title">体质测试数据驾驶舱</div>
      <!-- <div class="sys-temp"><div id="he-plugin-simple"></div></div> -->
      <div class="sys-temp">
        <el-select v-model="currSeason" placeholder="请选择" @change="selectChange" style="width: 120px">
          <el-option v-for="item in seasonList" :key="item.id" :label="item.year" :value="item.id"> </el-option>
        </el-select>
      </div>
    </div>
    <my-scale @changeSize="changeSize">
      <div
        class="d-aligncnter d-column"
        style="width: 1920px"
        :style="{
          'margin-top': 'calc(' + mySize + 'vw',
        }"
      >
        <div class="myleft d-aligncnter" style="font-size: 16px; height: 800px; width: 1920px">
          <div class="myleft-top d-aligncnter" style="width: 1920px">
            <div class="top-left d-column" style="width: 544px; height: 800px">
              <test-item :itemData="itemData"></test-item>
              <test-best :bestData="bestData"></test-best>
            </div>
            <div class="top-right d-column" style="width: 824px; margin-left: 10px">
              <div style="height: 435px; margin-top: -24px" class="d-aligncnter">
                <div><test-join :joinData="joinData"></test-join></div>
                <div>
                  <test-more-rate :passRate="passRate"></test-more-rate>
                </div>
              </div>
              <!-- <div style="width: 400px; display: none">
                <test-rate
                  :rateData="rateData"
                  :rateDataYear="rateDataYear"
                ></test-rate>
              </div> -->
              <div style="width: 800px">
                <test-detail ref="childScore" :healthRateData="healthRateData"></test-detail>
              </div>
            </div>
            <div class="myright d-column" style="width: 544px; height: 800px; margin: 16px">
              <TestNewBlock :GradeRateList="GradeRateList" :CollegeRateList="CollegeRateList"></TestNewBlock>
              <test-curr :currData="currData"></test-curr>
            </div>
          </div>
        </div>
        <div class="myleft-bottom" style="width: 1920px; height: 190px; margin-top: -16px">
          <test-dayly :testDayly="testDayly" :testDaylyDate="testDaylyDate"></test-dayly>
        </div>
      </div>
    </my-scale>
  </div>
</template>
<script>
import TestBest from './components/TestBest'
// import TestBranch from './components/TestBranch.vue'
import TestNewBlock from './components/TestNewBlock'
import TestCurr from './components/TestCurr'
import TestDayly from './components/TestDayly'
import TestItem from './components/TestItem'
import TestJoin from './components/TestJoin'
import TestMoreRate from './components/TestMoreRate'
// import TestRate from './components/TestRate.vue'
import TestDetail from './components/TestDetail'
import MyScale from './components/MyScale'
import {
  getItemScoreInfo,
  getCurrentMaxScore,
  getCurDatePersonNum,
  getCurrentPersonNum,
  getCurrentPassRate,
  getCollegePassRate,
  getCurrentFiveYearPassRate,
  getEntranceInfo,
  getHealthRate,
  getSeasonList,
  getGradeRate,
  getCollegeRate,
} from '@/api/api_healthCockpit'
export default {
  name: '',
  components: {
    TestDayly,
    TestItem,
    TestBest,
    TestJoin,
    // TestRate,
    TestMoreRate,
    // TestBranch,
    TestNewBlock,
    TestCurr,
    TestDetail,
    MyScale,
  },
  directives: {},
  data() {
    return {
      mySize: 5.208,
      currScale: 1,
      today: '',
      testDayly: [],
      testDaylyDate: [],
      rateData: [],
      rateDataYear: [],
      bestData: [],
      itemData: [],
      joinData: [],
      passRate: {},
      brachData: [],
      currData: [],
      timer: null,
      timer2: null,
      healthRateData: {},
      seasonList: [],
      currSeason: '',
      currSeasonId: '',
      GradeRateList: [],
      CollegeRateList: [],
    }
  },
  created() {
    window.addEventListener('load', this.placeholderPic)
    window.addEventListener('resize', this.placeholderPic)
    // 时间
    let nowDate = new Date()
    let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      date: nowDate.getDate(),
      hours: nowDate.getHours(),
      minutes: nowDate.getMinutes(),
      seconds: nowDate.getSeconds(),
    }
    let newmonth = date.month > 9 ? date.month : '0' + date.month
    let newday = date.date > 9 ? date.date : '0' + date.date
    this.today = date.year + '-' + newmonth + '-' + newday

    this.getListQc()
    this.getItemScore()
    this.currentMaxScore()
    this.currDatePersonNum()
    this.currentPersonNum()
    this.currentPassRate()
    this.collegePassRate()
    this.currentFiveYearPassRate()
    this.entranceInfo()
    this.healthRate()
    this.getYearGradeRate()
    this.getYearCollegeRate()
    //学期各学院数据
    this.timer = setInterval(() => {
      //   this.getItemScore()
      //   this.currentMaxScore()
      //   this.currDatePersonNum()
      this.currentPersonNum()
      //   this.currentPassRate()
      //   this.collegePassRate()
      // this.currentFiveYearPassRate()
      this.entranceInfo()
    }, 60000)
    this.timer2 = setInterval(() => {
      this.getItemScore()
      this.currentMaxScore()
      this.currDatePersonNum()
      //   this.currentPersonNum()
      this.currentPassRate()
      this.collegePassRate()
      this.currentFiveYearPassRate()
      this.healthRate()
      this.getYearGradeRate()
      this.getYearCollegeRate()
    }, 300000)
  },
  mounted() {
    window.WIDGET = {
      CONFIG: {
        modules: '02',
        background: '5',
        tmpColor: 'FFFFFF',
        tmpSize: '16',
        cityColor: 'FFFFFF',
        citySize: '16',
        aqiColor: 'FFFFFF',
        aqiSize: '16',
        weatherIconSize: '24',
        alertIconSize: '18',
        padding: '10px 10px 10px 10px',
        shadow: '0',
        language: 'auto',
        fixed: 'false',
        vertical: 'top',
        horizontal: 'left',
        key: '18dcc59e188b4b6684d470c4322bbefa',
      },
    }
    ;(function (d) {
      var c = d.createElement('link')
      c.rel = 'stylesheet'
      c.href = 'https://widget.heweather.net/simple/static/css/he-simple.css?v=1.4.0'
      var s = d.createElement('script')
      s.src = 'https://widget.heweather.net/simple/static/js/he-simple.js?v=1.4.0'
      var sn = d.getElementsByTagName('script')[0]
      sn.parentNode.insertBefore(c, sn)
      sn.parentNode.insertBefore(s, sn)
    })(document)
  },
  methods: {
    changeSize(size) {
      console.log('size:', size)
      this.currScale = size
      //   this.mySize = this.mySize / size
      this.mySize = 5.208 / size
    },
    //字体大小
    placeholderPic() {
      const clientWidth = document.documentElement.clientWidth
      const n = 8 * (clientWidth / 380)
      document.documentElement.style.fontSize = n + 'px'
    },
    //各项目得分统计
    getItemScore() {
      getItemScoreInfo(this.currSeasonId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getItemScoreInfo:', res.data)
          this.itemData = res.data.obj
        }
      })
    },
    currentMaxScore() {
      getCurrentMaxScore(this.currSeasonId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getCurrentMaxScore:', res.data)
          this.bestData = res.data.obj
        }
      })
    },
    currDatePersonNum() {
      getCurDatePersonNum().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getCurDatePersonNum:', res.data)
          this.testDayly = []
          this.testDaylyDate = []
          for (let i = 0; i < res.data.obj.length; i++) {
            this.testDayly.push(res.data.obj[i].count)
            this.testDaylyDate.push(res.data.obj[i].date)
          }
        }
      })
    },
    currentPersonNum() {
      getCurrentPersonNum(this.currSeasonId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getCurrentPersonNum:', res.data)
          this.joinData = res.data.obj
        }
      })
    },
    currentPassRate() {
      getCurrentPassRate(this.currSeasonId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getCurrentPassRate:', res.data)
          this.passRate = res.data.obj
        }
      })
    },
    collegePassRate() {
      getCollegePassRate(this.currSeasonId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getCollegePassRate:', res.data)
          this.brachData = res.data.obj
        }
      })
    },
    currentFiveYearPassRate() {
      getCurrentFiveYearPassRate().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getCurrentFiveYearPassRate:', res.data)
          this.rateData = []
          this.rateDataYear = []
          for (let i = 0; i < res.data.obj.length; i++) {
            this.rateData.push(res.data.obj[i].passRate)
            this.rateDataYear.push(res.data.obj[i].year)
          }
        }
      })
    },
    entranceInfo() {
      getEntranceInfo().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getEntranceInfo:', res.data)
          this.currData = res.data.obj
        }
      })
    },
    healthRate() {
      getHealthRate(this.currSeasonId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getHealthRate?:', res.data)
          this.healthRateData = res.data.obj
          this.$refs.childScore.refreshTest()
        }
      })
    },
    getListQc() {
      getSeasonList().then((res) => {
        console.log('getSeasonList?:', res.data)
        if (res.data.statusCode == 1) {
          this.seasonList = res.data.obj
          for (let i = 0; i < this.seasonList.length; i++) {
            if (this.seasonList[i].isCurrentPeriod) {
              this.currSeason = res.data.obj[i].year
              this.currSeasonId = res.data.obj[i].id
            }
          }
        }
      })
    },
    getYearGradeRate() {
      getGradeRate(this.currSeasonId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getGradeRate?:', res.data)
          this.GradeRateList = res.data.obj
        }
      })
    },
    getYearCollegeRate() {
      getCollegeRate(this.currSeasonId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getCollegeRate?:', res.data)
          this.CollegeRateList = res.data.obj
        }
      })
    },
    selectChange(e) {
      console.log('selectChange?:', this.seasonList)
      console.log('selectChange?:', e)
      //   this.currSeason = this.seasonList[e].year
      this.currSeasonId = e
      this.getItemScore()
      this.currentMaxScore()
      this.currDatePersonNum()
      this.currentPassRate()
      this.collegePassRate()
      this.entranceInfo()
      this.healthRate()
      this.getYearGradeRate()
      this.getYearCollegeRate()
      this.currentPersonNum()
    },
  },
  destroyed() {
    clearInterval(this.timer)
  },
}
</script>
<style scoped lang="scss">
.jsc-bg {
  width: 100vw;
  min-width: 1200px;
  height: 100vh;
  //   min-height: 800px;
  overflow: hidden;
  background: #09120f;
  color: #fff;
  .top {
    width: 100%;
    height: 5.208vw;
    background: url('../../assets/img/cockpit/top.svg') no-repeat;
    background-size: 100%;
    position: relative;
    .sys-title {
      width: 100%;
      height: 100%;
      line-height: 5.208vw;
      vertical-align: middle;
      text-align: center;
      font-size: 1rem;
    }
    .sys-date,
    .sys-temp {
      font-size: 0.5rem;
      position: absolute;
    }
    .sys-date {
      line-height: 44px;
      top: calc(2.604vw - 18px);
      left: 6vw;
    }
    .sys-temp {
      top: calc(2.604vw - 22px);
      right: 6vw;
      display: flex;
      flex-direction: row-reverse;
    }
  }
}
.sys-temp ::v-deep .s-sticker-tmp {
  font-size: 0.5rem !important;
}
.sys-temp ::v-deep img {
  height: 0.7rem !important;
  width: 0.7rem !important;
}
.sys-temp ::v-deep #weather-view-he {
  display: none !important;
}
// .sys-temp ::v-deep .el-input {
//   width: 40%;
//   margin-left: 60%;
// }
.sys-temp ::v-deep .el-input__inner {
  background: transparent !important;
  color: #fff !important;
  border: none !important;
  font-size: 0.5rem !important;
}
.el-select-dropdown {
  min-width: 200px !important;
  width: 200px !important;
}
.center {
  height: 66vh;
}

.left-box {
  width: 28%;
  height: 66vh;
}
.center-box {
  width: 44%;
}
.right-box {
  width: 28%;
}
.right-two {
  padding: 16px;
  margin: 16px;
  font-size: 0.3rem;
}
// .bottom {
//   width: 90vw;
// }
.sys-temp {
  z-index: 999;
}
</style>
